<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Question Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Type" label-position="inside">
                        <b-select v-model="question.type" expanded>
                            <option value="text">Basic Text Field</option>
                            <option value="textarea">Large Text Field</option>
                            <option value="dropdown">Drop Down Menu</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="question.title" maxlength="200"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Subtitle/Help" label-position="inside">
                        <b-input type="textarea" v-model="question.help" maxlength="1000"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-ballot-check" title="Question Options"/>

        <draggable v-model="question.options" handle=".handle">
            <transition-group>
                <card-list-item v-for="(option, index) in question.options" :key="index" class="t-card-list-item">
                    <template #icon><i class="fa-fw far fa-ballot-check"></i></template>
                    <template #content>
                        <div class="columns">
                            <div class="column">
                                {{ option }}
                            </div>
                            <div class="column is-1 has-text-right">
                                <i class="handle fas fa-bars" style="cursor: move"></i>
                            </div>
                            <div class="column is-2 has-text-right">
                                <b-button size="is-small" @click="removeOption(option)">Remove</b-button>
                            </div>
                        </div>
                    </template>
                </card-list-item>
            </transition-group>
        </draggable>

        <container-list-item>
            <card-list-item class="pb-5">
                <template #icon><i class="fa-fw fas fa-plus"></i></template>
                <template #content>
                    <div class="columns">
                        <div class="column is-10">
                            <b-field>
                                <b-input placeholder="Option Title" v-model="newOption.title" expanded></b-input>
                            </b-field>
                        </div>
                        <div class="column has-text-right">
                            <p class="control">
                                <button class="button is-primary" @click="addOption"><i class="far fa-plus"></i></button>
                            </p>
                        </div>
                    </div>
                </template>
            </card-list-item>

        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import draggable from 'vuedraggable';

    export default {
        name: 'RmcQuestionForm',
        props: {
            question: {
                type: Object,
                required: true
            }
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList, draggable},
        data: function() {
            return {
                newOption: {}
            };
        },
        methods: {
            addOption: function() {
                this.question.options.push(this.newOption.title);
                this.newOption.title = '';
            },
            removeOption: function(option) {
                this.question.options.splice(this.question.options.indexOf(option), 1);
            }
        },
        mounted: function() {

        }
    };
</script>
